export const hasNonEssentialConsentBeenWithdrawn = (prevServicesConsent, currServicesConsent)=>Object.entries(prevServicesConsent).some(([id, service])=>!service.essential && service.consent && !currServicesConsent?.[id]?.consent);
export const collectServicesConsent = (servicesData)=>Object.values(servicesData || {}).reduce((services, { consent, essential, name })=>{
        services[name] = {
            consent: consent?.given,
            essential: essential
        };
        return services;
    }, {});

//# sourceMappingURL=ConsentManager.helpers.js.map